import { render, staticRenderFns } from "./FormControl.vue?vue&type=template&id=71fa9118&scoped=true&"
import script from "./FormControl.vue?vue&type=script&lang=js&"
export * from "./FormControl.vue?vue&type=script&lang=js&"
import style0 from "./FormControl.vue?vue&type=style&index=0&id=71fa9118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fa9118",
  null
  
)

export default component.exports